import{ useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { useSEO } from "../../hooks/useSEO";
import Layout from "../../components/Layout";
import PageHeader from "../../components/ui/PageHeader";
import { useTheme } from "../../theme/ThemeProvider";
import faqData from "../../data/faqData.json";
import { FAQ_ROUTE } from "../../routes/constant";

const Faqs = () => {
  const { isDarkMode } = useTheme();
  const { breadcrumb, header, faqs } = faqData;
  const [openItems, setOpenItems] = useState({});

  const breadcrumbItems = [
    {
      label: breadcrumb.home.label,
      path: breadcrumb.home.path,
      icon: breadcrumb.home.icon,
    },
  ];

  const currentPage = {
    label: breadcrumb.current.label,
    path: breadcrumb.current.path,
  };

  const toggleItem = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // Use SEO hook
  useSEO(FAQ_ROUTE);

  return (
    <Layout>
      <PageHeader
        title={header.title}
        breadcrumbItems={breadcrumbItems}
        currentPage={currentPage}
      />

      <div
        className={`transition-colors duration-200 ${
          isDarkMode ? "bg-gray-900" : "bg-gray-50"
        }`}
      >
        <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            {/* FAQ Items */}
            <div className="space-y-3">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className={`rounded-lg overflow-hidden transition-all duration-200 ${
                    isDarkMode
                      ? "bg-gray-800 border border-gray-700"
                      : "bg-white border border-gray-200 shadow-sm"
                  }`}
                >
                  {/* Question Button */}
                  <button
                    onClick={() => toggleItem(faq.id)}
                    className={`flex justify-between items-center w-full px-5 py-4 text-left focus:outline-none transition-colors duration-200 ${
                      isDarkMode ? "hover:bg-gray-750" : "hover:bg-gray-50"
                    } ${openItems[faq.id] ? (isDarkMode ? "bg-gray-750" : "bg-gray-50") : ""}`}
                    aria-expanded={openItems[faq.id]}
                  >
                    <span
                      className={`text-sm font-medium pr-8 md:text-base ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      {faq.question}
                    </span>
                    <span className="flex-shrink-0">
                      {openItems[faq.id] ? (
                        <FiMinus className={`w-4 h-4 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`} />
                      ) : (
                        <FiPlus className={`w-4 h-4 ${isDarkMode ? "text-gray-400" : "text-gray-500"}`} />
                      )}
                    </span>
                  </button>

                  {/* Answer Panel */}
                  <div
                    className={`transition-all duration-300 ease-in-out overflow-hidden ${
                      openItems[faq.id]
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div
                      className={`px-5 pb-4 pt-2 border-t ${
                        isDarkMode
                          ? "border-gray-700 text-gray-400"
                          : "border-gray-200 text-gray-600"
                      }`}
                    >
                      <p className="text-sm leading-relaxed md:text-base">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Faqs;